import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const loadingStyle = {
  width: 50,
  margin: '10rem auto',
  height: 600,
};

const Loading = ({style=loadingStyle}) => (
  <div style={style}>
    <CircularProgress color="primary" />
  </div>
);

export default Loading;
